module.exports = __webpack_public_path__ + "static/media/new_movements.c90606ad.svg";